export default __webpack_public_path__ + "static/tab-image-347ad2a268d4f0d9a9837a3e05098865.png";